import { saveAs } from 'file-saver';
import { downloadAttachmentForSearch, getInboxEmailAttachment } from 'wisestep-api';

import { InboxEmailLogsType } from '../../hooks/useEmailLogs';

export interface IConfiguredAccountsDTO {
  id?: string;
  recruiterName: string;
  recruiterEmail: string;
  emailServer: string;
  password?: string;
  emailServerPort: number;
  emailSync: string;
  bcc: string;
  excludedDomain: string;
  excludeIncomingDomain: string;
  excludeOutgoingDomain: string;
  availableFields: string;
  attachment?: string;
  status: string;
  createdBy?: string;
  syncDuration: number;
}

export interface singleDataHandleType {
  configuredAccounts: IConfiguredAccountsDTO[];
  inboxData: InboxEmailLogsType;
}

export interface InboxActionType {
  subject?: string;
  to?: string[];
  body?: string;
  showForm: boolean;
}

export interface InBoxContentData {
  to: string;
  from: string;
  subject: string;
  message: string;
  fromName: string;
  recruiterId: string;
  recruiterName: string;
  sent_on: string;
  attachments?: attachmentType[];
  messageId: string;
  ccList: string;
  bccList: string;
  extractedBody?: string;
}
export type IconProps = {
  statusColor: string;
};
export type InboxFiltersType = {
  filter: string;
  seen: string;
};

export interface singleDataType {
  content: InBoxContentData;
  showDrawer: boolean;
}
export interface attachmentType {
  fileName: string;
  uuid: string;
}
export const defaultInboxData: InBoxContentData = {
  to: '',
  from: '',
  subject: '',
  message: '',
  fromName: '',
  recruiterId: '',
  recruiterName: '',
  sent_on: '',
  messageId: '2',
  bccList: '',
  ccList: '',
};
export type InboxEmailPropTypes = {
  onActionCallback: (data: InboxActionType) => void;
  hasAttachmentsCallback?: (hasAttachments: boolean) => void;
  getInboxStats?: (email: string) => void;
};
export interface handleFilterAndPageType {
  filter: InboxFiltersType;
  page: number;
}

export const defaultInboxRecord = [
  {
    messageId: '',
    messageNumber: 1,
    fromEmail: '',
    subject: '',
    toEmail: '',
    receivedDate: '',
    seen: false,
    bccList: '',
    ccList: '',
  },
];
export const defaultInboxLogs = {
  lastIndexRead: 0,
  totalCount: 0,
  records: defaultInboxRecord,
};

export const downloadHelper = (downloadDetails) => {
  const headers = downloadDetails.headers;
  const file = new Blob([downloadDetails.data], {
    type: headers['content-type'],
  });
  saveAs(file, headers['content-disposition'].replace('attachment;filename=', ''));
};

export const extractEmail = (emailText: string) => {
  const regexForEmail = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/g;
  const regexForName = /^([^@]*)@/g;
  const matches = regexForEmail.exec(emailText);
  let emailAndName = { email: '', name: '' };

  if (matches) {
    const extractedName = regexForName.exec(matches[1]);
    emailAndName = {
      email: matches[1],
      name: extractedName ? extractedName[1].split('.').join(' ') : '',
    };
  }
  return emailAndName;
};

export const getTimeString = (dateString: string) => {
  const date = new Date(dateString);
  const today = new Date();

  const isSameYear = date.getFullYear() === today.getFullYear();
  const isSameMonth = isSameYear && date.getMonth() === today.getMonth();
  const isSameDay = isSameMonth && date.getDate() === today.getDate();

  if (isSameDay) {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
  } else if (isSameMonth) {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  } else if (isSameYear) {
    return date.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
  } else {
    return date.toLocaleDateString([], { year: 'numeric', month: 'short', day: 'numeric' });
  }
};

export const downloadAttachment = async (
  messageId: string,
  uuid: string,
  singleDataHandle: singleDataHandleType
) => {
  try {
    downloadHelper(
      await getInboxEmailAttachment(
        singleDataHandle.configuredAccounts[0].recruiterEmail,
        messageId,
        uuid
      )
    );
  } catch (error) {
    console.log(error);
  }
};

export const downloadSearchAttachment = async (email: string, url: string) => {
  try {
    downloadHelper(await downloadAttachmentForSearch(url, email));
  } catch (error) {
    console.log(error);
  }
};
export const getUniqArray = (a: string[]) => {
  return Array.from(new Set(a));
};

export const initialUsersArray: string[] = [
  'akash.goud@avanceservices.uk',
  'vivek.c@avanceservices.uk',
  'jagadish.a@avanceservices.uk',
  'ravula.sai@avanceservices.us',
  'naga.aditya@avanceservices.us',
  'matthew.thomas@avanceservices.us',
  'himamsh.kilubatla@wisestep-inc.com',
  'akhil.bharadwaj@wisestep-inc.com',
  'bhargavi.a@wisestep-inc.com',
  'himamsh@nivahata.com',
  'wscrm@avanceunlimited.com',
  'akshay.kumar@avanceservices.us',
  'fortestingfeatures1@gmail.com',
  'madhuri.chidri@avanceservices.co.uk',
  'shirisha.reddy@avanceservices.co.uk',
  'godwin.j@avanceservices.us',
  'hadi.fardan@avanceservices.us',
  'alexander.s@avanceservices.us',
  'maria.medlina@avanceservices.us',
  'hruday.sairi@avanceservices.us',
  'rakesh.r@avanceservices.us',
  'sowmya.rapole@avanceservices.us',
  'tejasri.chinta@avanceservices.us',
  'roja.m@avanceservices.us',
  'anil.arroju@avanceservices.us',
  'sheeba.fatima@avanceservices.us',
  'mrigank.singh@wisestep-inc.com',
];
